import ProxyButton from '../common/ProxyButton';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';

export default function BarcodeContainer({ oktaBarcodeContainer }: { oktaBarcodeContainer: JQuery }) {
  const cantScanLink: JQuery = oktaBarcodeContainer.find('.cannot-scan-link');
  const qrCodeImage = oktaBarcodeContainer.find('.qrcode');
  return (
    <div
      className={'qrcode-container fe_u_margin--top-large'}
    >
      <div className={'fe_u_margin--bottom-small'}>
        <img className={'qrcode'} src={qrCodeImage.attr('src')} alt={qrCodeImage.attr('alt')} />
      </div>
      <ProxyButton
        oktaButton={cantScanLink}
        fullWidth
        variant="tertiary"
        onClick={() => {
          AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['GOOGLE']}TotpManualSetup::Landing`);
        }}
      />
    </div>
  );
}
